import { useEffect } from "react";
import { api } from "../../api/apiSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setVehicles } from "../vehicles/vehiclesSlice";
import {
  logout,
  selectRefreshToken,
  selectToken,
  setCredentials,
} from "./authSlice";

const AuthSessionSync: React.FC = () => {
  const dispatch = useAppDispatch();
  const token = useAppSelector(selectToken);
  const refreshToken = useAppSelector(selectRefreshToken);

  useEffect(() => {
    const onStorage = (event: StorageEvent) => {
      if (
        event.key !== null &&
        event.key !== "token" &&
        event.key !== "refreshToken" &&
        event.key !== "user"
      ) {
        return;
      }

      const storedToken = localStorage.getItem("token");
      const storedRefreshToken = localStorage.getItem("refreshToken");
      const userString = localStorage.getItem("user");

      if (!storedToken || !storedRefreshToken || !userString) {
        dispatch(api.util.resetApiState());
        dispatch(setVehicles([]));
        dispatch(logout());
        return;
      }

      if (storedToken === token && storedRefreshToken === refreshToken) {
        return;
      }

      try {
        const user = JSON.parse(userString);
        dispatch(
          setCredentials({
            user,
            accessToken: storedToken,
            refreshToken: storedRefreshToken,
          }),
        );
      } catch {
        dispatch(api.util.resetApiState());
        dispatch(setVehicles([]));
        dispatch(logout());
      }
    };

    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [dispatch, token, refreshToken]);

  return null;
};

export default AuthSessionSync;
